export const localeRoutePath = process.env.NEXT_PUBLIC_LOCALE
  ? process.env.NEXT_PUBLIC_LOCALE + '/'
  : '';
